import { render, staticRenderFns } from "./no_rights.vue?vue&type=template&id=e82f3a32&scoped=true&"
import script from "./no_rights.vue?vue&type=script&lang=js&"
export * from "./no_rights.vue?vue&type=script&lang=js&"
import style0 from "./no_rights.vue?vue&type=style&index=0&id=e82f3a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82f3a32",
  null
  
)

export default component.exports